export default __webpack_public_path__ + "static/media/as.c283c0e5.svg";